<template>
  <font-awesome-icon v-if="icon" class="shopping-list-icon text-primary mr-2" :icon="icon" />
</template>
<script>
const LIST_ICON_MAP = {
  CUSTOM: '',
  FAVORITES: 'heart',
  SAVE_FOR_LATER: 'bookmark',
};
export default {
  name: 'WCShoppingListIcon',
  props: {
    shoppingListType: {
      type: String,
      required: true,
    },
  },
  computed: {
    icon() {
      return LIST_ICON_MAP[this.shoppingListType];
    },
  },
};
</script>
